module.exports = __webpack_public_path__ + "static/img/carousel_02.a4e7cdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel_02.png
// module id = bFT7
// module chunks = 0